/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_EnableInputs */

const en_live_caption_enable = /** @type {(inputs: Live_Caption_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable`)
};

const fr_live_caption_enable = /** @type {(inputs: Live_Caption_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer`)
};

const de_live_caption_enable = /** @type {(inputs: Live_Caption_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivieren`)
};

const it_live_caption_enable = /** @type {(inputs: Live_Caption_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilitare`)
};

const ru_live_caption_enable = /** @type {(inputs: Live_Caption_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Давать возможность`)
};

const es_live_caption_enable = /** @type {(inputs: Live_Caption_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir`)
};

const zh_cn2_live_caption_enable = /** @type {(inputs: Live_Caption_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使能够`)
};

const ja_live_caption_enable = /** @type {(inputs: Live_Caption_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効にする`)
};

const hi_live_caption_enable = /** @type {(inputs: Live_Caption_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्षम`)
};

const pt_pt2_live_caption_enable = /** @type {(inputs: Live_Caption_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar`)
};

/**
* | output |
* | --- |
* | "Enable" |
*
* @param {Live_Caption_EnableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_enable = /** @type {((inputs?: Live_Caption_EnableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_EnableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_enable(inputs)
	if (locale === "de") return de_live_caption_enable(inputs)
	if (locale === "it") return it_live_caption_enable(inputs)
	if (locale === "ru") return ru_live_caption_enable(inputs)
	if (locale === "es") return es_live_caption_enable(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_enable(inputs)
	if (locale === "ja") return ja_live_caption_enable(inputs)
	if (locale === "hi") return hi_live_caption_enable(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_enable(inputs)
	return en_live_caption_enable(inputs)
});